import { render, staticRenderFns } from "./BusinessDetail.vue?vue&type=template&id=36ab9e33&scoped=true&"
import script from "./BusinessDetail.vue?vue&type=script&lang=js&"
export * from "./BusinessDetail.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDetail.vue?vue&type=style&index=0&id=36ab9e33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab9e33",
  null
  
)

export default component.exports